import React, { useState } from "react";
import { Link } from 'react-router-dom';
import Geohublogo from './styles/Geohublogo.svg';
// Removing image import
// import disimg from './Images/disimg.png'; // Moved to src/assets/images/


// Removing background images array
// const BACKGROUND_IMAGES = [
//   disimg,
//   
// ];

const Disclaimer = ({ onUnderstand, onClose, onShowPromptGuide }) => {
    // State to track the current step in the disclaimer flow
    const [currentStep, setCurrentStep] = useState(0);
    // State to track copy notification visibility
    const [showCopyAlert, setShowCopyAlert] = useState(false);
    
    const handleFinish = () => {
        // Save to localStorage that user has seen and acknowledged the disclaimer with a 7-day expiration
        const expirationDate = new Date();
        expirationDate.setDate(expirationDate.getDate() + 7); // Set expiration to 7 days from now
        
        const disclaimerData = {
            acknowledged: true,
            expiresAt: expirationDate.getTime() // Store as timestamp
        };
        
        localStorage.setItem('hasSeenDisclaimer', JSON.stringify(disclaimerData));
        
        // Call the callback function if provided
        if (onUnderstand) {
            onUnderstand();
        }
        
        // Show the prompt guide when finishing
        if (onShowPromptGuide) {
            onShowPromptGuide(true);
        }
    };
    
    const handleNextStep = () => {
        if (currentStep < 2) {
            setCurrentStep(currentStep + 1);
        } else {
            handleFinish();
        }
    };

    const handleCloseClick = () => {
        if (onClose) {
            onClose();
        }
    };
    
    // Function to copy text to clipboard
    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text).then(() => {
            setShowCopyAlert(true);
            setTimeout(() => setShowCopyAlert(false), 2000); // Hide after 2 seconds
        }).catch(err => {
            console.error('Failed to copy text: ', err);
        });
    };

    // Function to directly navigate to a specific step
    const goToStep = (step) => {
        setCurrentStep(step);
    };

    // Render small dots for step indicators
    const renderStepIndicators = () => {
        return (
            <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                gap: '6px',
                margin: '12px 0'
            }}>
                {[0, 1, 2].map(step => (
                    <div 
                        key={step}
                        onClick={() => goToStep(step)}
                        style={{
                            width: '8px',
                            height: '8px',
                            borderRadius: '50%',
                            backgroundColor: currentStep === step ? '#2241dd' : '#d0d0d0',
                            cursor: 'pointer',
                            transition: 'background-color 0.3s ease'
                        }}
                    />
                ))}
            </div>
        );
    };

    // Render different content based on the current step
    const renderStepContent = () => {
        switch (currentStep) {
            case 0:
                return (
                    <>
                        {/* Removing image container div */}
                        {/* <div 
                            onClick={handleCloseClick}
                            style={{
                                position: 'absolute',
                                top: 10,
                                right: 10,
                                background: 'rgba(0,0,0,0.1)',
                                borderRadius: '50%',
                                width: '24px',
                                height: '24px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                cursor: 'pointer'
                            }}
                        >
                            <span style={{ 
                                fontSize: '16px', 
                                fontWeight: 'bold',
                                lineHeight: '16px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: '100%',
                                height: '100%',
                                marginTop: '-2px'
                            }}>×</span>
                        </div> */}
                        
                        <p style={{ 
                            textAlign: "left", 
                            fontFamily: "Lato, sans-serif", 
                            fontSize: "14px", 
                            lineHeight: "1.5", 
                            margin: "10px 0 15px",
                            padding: "0 5px"
                        }}>
                            <strong>Disclaimer:</strong> GeoHub is an AI chatbot developed with 
                            commercial (LLM) software. Please be aware that as a GPT 4.0 
                            system, it may occasionally provide inaccurate 
                            information, and we encourage you to share any 
                            glitches or new knowledge for human review to help 
                            us improve.
                            <br /><br />
                            By proceeding to use GeoHub you acknowledge that you 
                            are interacting with an AI system.
                        </p>
                        
                        {renderStepIndicators()}
                        
                        <div style={{ display: 'flex', justifyContent: 'center', gap: '15px', marginTop: '10px', marginBottom: '10px' }}>
                            <button
                                type="button"
                                onClick={() => window.open('https://www.encardio.com/', '_blank')}
                                style={{
                                    backgroundColor: '#f0f0f0',
                                    color: '#333',
                                    padding: '12px 30px',
                                    borderRadius: '40px',
                                    border: 'none',
                                    cursor: 'pointer',
                                    fontWeight: '500',
                                    fontSize: '15px',
                                    width: '150px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}
                            >
                                Decline
                            </button>
                            
                            <button
                                type="button"
                                onClick={handleNextStep}
                                style={{
                                    backgroundColor: '#2241dd',
                                    color: 'white',
                                    padding: '12px 30px',
                                    borderRadius: '40px',
                                    border: 'none',
                                    cursor: 'pointer',
                                    fontWeight: '500',
                                    fontSize: '15px',
                                    width: '150px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}
                            >
                                Accept <span style={{ fontSize: '18px', marginLeft: '5px' }}></span>
                            </button>
                        </div>
                    </>
                );
            case 1:
                return (
                    <>
                        {/* Removing image container div */}
                        {/* <div 
                            onClick={handleCloseClick}
                            style={{
                                position: 'absolute',
                                top: 10,
                                right: 10,
                                background: 'rgba(0,0,0,0.1)',
                                borderRadius: '50%',
                                width: '24px',
                                height: '24px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                cursor: 'pointer'
                            }}
                        >
                            <span style={{ 
                                fontSize: '16px', 
                                fontWeight: 'bold',
                                lineHeight: '16px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: '100%',
                                height: '100%',
                                marginTop: '-2px'
                            }}>×</span>
                        </div> */}
                        
                        <p style={{ 
                            textAlign: "left", 
                            fontFamily: "Lato, sans-serif", 
                            fontSize: "14px", 
                            lineHeight: "1.5", 
                            margin: "10px 0 15px",
                            padding: "0 5px"
                        }}>
                            GeoHub is your AI partner of choice for geotechnical 
                            & civil engineering. Analyze complex project data, 
                            extract key document insights, and visualize 
                            project trends using natural language.
                            <br /><br />
                            Built on 55+ years of Encardio-rite's domain expertise, 
                            GeoHub delivers deep intelligence, empowering you to 
                            design, build, & manage with data-driven efficiency.
                        </p>
                        
                        {renderStepIndicators()}
                        
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px', marginBottom: '10px' }}>
                            <button
                                type="button"
                                onClick={handleNextStep}
                                style={{
                                    backgroundColor: '#2241dd',
                                    color: 'white',
                                    padding: '12px 30px',
                                    borderRadius: '40px',
                                    border: 'none',
                                    cursor: 'pointer',
                                    fontWeight: '500',
                                    fontSize: '15px',
                                    width: '150px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}
                            >
                                Next <span style={{ fontSize: '18px', marginLeft: '5px' }}>→</span>
                            </button>
                        </div>
                    </>
                );
            case 2:
                return (
                    <>
                        {/* Removing image container div */}
                        {/* <div 
                            onClick={handleCloseClick}
                            style={{
                                position: 'absolute',
                                top: 10,
                                right: 10,
                                background: 'rgba(0,0,0,0.1)',
                                borderRadius: '50%',
                                width: '24px',
                                height: '24px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                cursor: 'pointer'
                            }}
                        >
                            <span style={{ 
                                fontSize: '16px', 
                                fontWeight: 'bold',
                                lineHeight: '16px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: '100%',
                                height: '100%',
                                marginTop: '-2px'
                            }}>×</span>
                        </div> */}
                        
                        <p style={{ 
                            textAlign: "left", 
                            fontFamily: "Lato, sans-serif", 
                            fontSize: "14px", 
                            lineHeight: "1.5", 
                            margin: "10px 0 15px",
                            padding: "0 5px"
                        }}>
                            <strong>How to use:</strong> Interact with GeoHub seamlessly by typing
                            your geotechnical and civil engineering questions in
                            natural language, now in your preferred language.
                            <br /><br />
                            Ask GeoHub to analyze complex project data, extract
                            insights from documents, or visualize
                            project results.
                        </p>
                        
                        {renderStepIndicators()}
                        
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px', marginBottom: '10px' }}>
                            <button
                                type="button"
                                onClick={handleFinish}
                                style={{
                                    backgroundColor: '#2241dd',
                                    color: 'white',
                                    padding: '12px 30px',
                                    borderRadius: '40px',
                                    border: 'none',
                                    cursor: 'pointer',
                                    fontWeight: '500',
                                    fontSize: '15px',
                                    width: '150px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}
                            >
                                Finish
                            </button>
                        </div>
                    </>
                );
            default:
                return null;
        }
    };

    return (
        <div className="popup" style={{
            position: 'fixed',
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            backdropFilter: 'blur(1.1px)',
            zIndex: 1000
        }}>
            <div className="popup-content" style={{ 
                maxWidth: '400px',
                width: '95%',
                padding: '10px 20px 5px',
                borderRadius: '10px',
                boxShadow: '0 5px 15px rgba(0,0,0,0.2)',
                backgroundColor: 'white',
                margin: '0 auto',
                position: 'relative'
            }}>
                {renderStepContent()}
            </div>
        </div>
    );
};

export default Disclaimer;